import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { CardSummarySinglelineComponent } from 'src/app/core/card-summary-singleline/card-summary-singleline.component';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { GenericDD } from 'src/app/model/generic-data';
import { MissionDto, UNLOCK_TYPE_LABEL, UnlockType } from '../gestione-missioni/missioni-dto';
import { MissioneEsplorativaLocationFields, MissioniEsplorativeFilters } from './missioni-esplorative-dto';
import { MissioniEsplorativeService } from './missioni-esplorative.service';

@Component({
  selector: 'app-missioni-esplorative',
  imports: [CardSummarySinglelineComponent, FormsModule, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './missioni-esplorative.component.html',
  styleUrl: './missioni-esplorative.component.scss'
})
export class MissioniEsplorativeComponent implements OnInit, OnDestroy {

  options: GridColConfig[] = [];
  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;

  missioni: Array<MissionDto & MissioneEsplorativaLocationFields> = [];
  filtri: MissioniEsplorativeFilters = {
    location: '',
    type: '',
    poi: ''
  };
  locationOptions: GenericDD[] = [];
  typeOptions: GenericDD[] = [];
  poiOptions: GenericDD[] = [];
  ricercaInCorso = false;

  private theEnd$ = new Subject<void>();

  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private missioniEsplorativeService: MissioniEsplorativeService,
    private toast: ToastService
  ) {
  }

  ngOnInit(): void { //TODO make lazy loading
    this.localstorage.setTitolo('Missioni esplorative');
    this.loadMissioni();
    this.loadFilterOptions();

    this.options = [
      {
        type: 'button',
        name: 'Modifica',
        field: 'none',
        icon: 'pencil',
        cssClass: 'edit-button',
        fieldOptions: {},
        width: '40'
      },
      {
        type: 'text',
        name: 'Nome',
        field: 'name',
        fieldOptions: {}
      },
      {
        type: 'text',
        name: 'Descrizione',
        field: 'description',
        fieldOptions: {}
      },
      {
        type: 'button',
        name: 'Elimina',
        field: 'none',
        icon: 'trash',
        cssClass: 'delete-button',
        fieldOptions: {},
        width: '40'
      }
    ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id);
    }
    if (event.action == 'elimina') {
      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }
  }

  edit(id: string): void {
    this.router.navigate([`/home/missioni-esplorative/${id}`]);
  }

  add(): void {
    this.router.navigate([`/home/missioni-esplorative/new`]);
  }

  search(): void {
    this.ricercaInCorso = true;

    this.missioniEsplorativeService.search(this.filtri).pipe(take(1)).subscribe({
      next: (data: Array<MissionDto & MissioneEsplorativaLocationFields>) => {
        this.missioni = data.filter((missione) => missione.isSecondary === true);
        this.ricercaInCorso = false;
      },
      error: () => {
        this.toast.error('Errore durante la ricerca delle missioni');
        this.ricercaInCorso = false;
      }
    });
  }

  resetFilters(): void {
    this.filtri = {
      location: '',
      type: '',
      poi: ''
    };
    this.loadMissioni();
  }

  delete(id: string) {
    this.missioniEsplorativeService.delete(id).pipe(take(1)).subscribe({
      next: () => {
        this.toast.success('Missione esplorativa eliminata');
        this.loadMissioni();
      }
    });
  }

  unlockTypeToString(unlockType?: UnlockType): string {
    return unlockType ? UNLOCK_TYPE_LABEL[unlockType] : '-';
  }

  private loadMissioni(): void {
    this.ricercaInCorso = true;

    this.missioniEsplorativeService.getAll().pipe(take(1)).subscribe({
      next: (data: Array<MissionDto & MissioneEsplorativaLocationFields>) => {
        this.missioni = data.filter((missione) => missione.isSecondary === true);
        this.ricercaInCorso = false;
      },
      error: () => {
        this.toast.error('Errore durante il caricamento delle missioni');
        this.ricercaInCorso = false;
      }
    });
  }

  private loadFilterOptions(): void {
    this.missioniEsplorativeService.getLocationOptions().pipe(take(1)).subscribe({
      next: (data: GenericDD[]) => {
        this.locationOptions = data;
      },
      error: () => {
        this.locationOptions = [];
      }
    });

    this.missioniEsplorativeService.getTypeOptions().pipe(take(1)).subscribe({
      next: (data: GenericDD[]) => {
        this.typeOptions = data;
      },
      error: () => {
        this.typeOptions = [];
      }
    });

    this.missioniEsplorativeService.getPoiOptions().pipe(take(1)).subscribe({
      next: (data: GenericDD[]) => {
        this.poiOptions = data;
      },
      error: () => {
        this.poiOptions = [];
      }
    });
  }
}
